import { render, staticRenderFns } from "./Group_Rating.vue?vue&type=template&id=53efc3e3&scoped=true"
import script from "./Group_Rating.vue?vue&type=script&lang=js"
export * from "./Group_Rating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53efc3e3",
  null
  
)

export default component.exports